import React from "react"
import { Button, Typography } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"
import { InsuranceRecoveryFooter } from "./InsuranceRecoveryFooter"

type Props = { onBack: () => void; onRetry?: () => void }
export function InsuranceErrorStep({ onBack, onRetry }: Props): JSX.Element {
  return (
    <>
      <Typography variant="h3" component="h1">
        <FormattedMessage defaultMessage="Something went wrong" />
      </Typography>
      <Typography role="alert">
        <FormattedMessage defaultMessage="The coverage check couldn't be completed." />
      </Typography>
      <InsuranceRecoveryFooter onBack={onBack}>
        {onRetry && (
          <Button variant="outlined" color="secondary" size="small" onClick={onRetry}>
            <FormattedMessage defaultMessage="Try again" />
          </Button>
        )}
      </InsuranceRecoveryFooter>
    </>
  )
}
